"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Camera } from "lucide-react";
import { Badge } from "@/components/ui/badge";
function FooterMenu() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-2">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 bg-muted/50 animate-pulse rounded-md" />)}
      </div>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-secondary transition-colors flex items-center gap-2">
            <span className="text-secondary/50">{'>'}</span> {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const socials = [{
    name: 'Instagram',
    url: '#'
  }, {
    name: 'Facebook',
    url: '#'
  }, {
    name: 'LinkedIn',
    url: '#'
  }];
  const companyCamUrl = "https://companycam.com/hardworkingyoungmen";
  return <section data-section-id="259839" id="footer" className="dark bg-background text-foreground py-16 border-t border-border/30 font-default text-sm">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 lg:gap-8">
          
          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage">
              <WvcLogo className="h-8 w-auto text-foreground" />
            </Link>
            <p className="text-muted-foreground leading-relaxed max-w-xs">
              HARD WORKING YOUNG MEN LANDSCAPING. We work hard so you can enjoy more. Elite outdoor design for the modern estate.
            </p>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-default font-bold text-foreground tracking-wider uppercase text-sm">
              Navigation
            </h3>
            <MenuProvider menu_id="footer_menu">
              <FooterMenu />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-default font-bold text-foreground tracking-wider uppercase text-sm">
              Connect
            </h3>
            <ul className="space-y-3">
              {socials.map((social, i) => <li key={social.name} data-index={i}>
                  <Link to={social.url} className="text-muted-foreground hover:text-chart-2 transition-colors flex items-center gap-2">
                    <span className="text-chart-2/50">{'>'}</span> {social.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-default font-bold text-foreground tracking-wider uppercase text-sm">
              Live Project Feed
            </h3>
            <div className="space-y-4">
              <p className="text-muted-foreground flex items-start gap-3 leading-relaxed">
                <Camera className="size-5 text-secondary shrink-0 mt-0.5" />
                <span>Real-time project updates & progress photos</span>
              </p>
              {companyCamUrl && <Link to={companyCamUrl} newTab className="inline-block">
                  <Badge variant="secondary" className="bg-secondary text-secondary-foreground hover:bg-secondary/80 px-4 py-1.5 rounded-lg transition-all cursor-pointer border-none shadow-md">
                    Follow Us on CompanyCam →
                  </Badge>
                </Link>}
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6 lg:items-end">
            <h3 className="font-default font-bold text-foreground tracking-wider uppercase text-sm lg:text-right">
              Service Status
            </h3>
            <div className="flex items-center gap-3 bg-secondary/10 px-4 py-3 rounded-lg border border-border/30 w-fit">
              <div className="relative flex h-2.5 w-2.5">
                <span className="animate-ping absolute inline-flex h-full w-full bg-secondary opacity-75 rounded-lg"></span>
                <span className="relative inline-flex h-2.5 w-2.5 bg-secondary rounded-lg"></span>
              </div>
              <span className="text-secondary font-semibold tracking-widest uppercase">
                Active
              </span>
            </div>
          </div>

        </div>

        {}
        <div className="mt-16 pt-8 border-t border-border/30 flex flex-col md:flex-row justify-between items-center gap-4 text-muted-foreground/50">
          <p>&copy; {new Date().getFullYear()} HARD WORKING YOUNG MEN. ALL RIGHTS RESERVED.</p>
          <p className="tracking-widest uppercase text-[10px]">Design by Elite Landscaping Atelier</p>
        </div>
      </div>
    </section>;
}